module.exports = {"validation":{"required":"Bu alan zorunludur","email":"Geçersiz e-posta adresi"}}